<template>
  <v-list three-line>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          {{ $t(product.title.token, product.title.values) }}
          <v-chip color="success" small>
            {{ $t("report.thgProducts.popular") }}
          </v-chip>
        </v-list-item-title>
        <v-list-item-subtitle v-html="product.years.join(' & ')" />
        <div v-for="(price, idx) in product.prices" :key="idx" :class="idx !== product.prices.length - 1 ? 'mb-2' : ''">
          <v-list-item-subtitle v-if="price.subtitle" v-html="price.subtitle" />
          <v-list-item-subtitle v-if="price.description" v-html="price.description" />
          <v-list-item-subtitle v-if="price.hint" v-html="price.hint" />
          <v-list-item-subtitle v-if="showPrice">
            <b> {{ $t(price.prefix) + " " + price.totalAmountAsString }}</b>
          </v-list-item-subtitle>
        </div>
      </v-list-item-content>
      <v-list-item-action>
        <v-radio :value="product.years"></v-radio>
      </v-list-item-action>
    </v-list-item>
    <div class="text-caption mb-4 mx-4 d-flex align-center">
      <v-icon small class="mr-1">mdi-check-decagram</v-icon>
      {{ $t("report.thgProducts.multipleYear", { amount: numberToWord(product.prices.length) }) }}
    </div>
  </v-list>
</template>

<script lang="ts">
import { IPriceConfig } from "@/store/models/thg/active-price";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class ThgProductsPriceComboCard extends Vue {
  @Prop({ default: false })
  showPrice!: boolean;

  @Prop()
  product!: {
    years: number[];
    title: {
      token: string;
      values: {
        year: number;
      };
    };
    prices: IPriceConfig[];
  };

  numberToWord(num: number) {
    const germanWords = [
      "common.numbers.none",
      "common.numbers.one",
      "common.numbers.two",
      "common.numbers.three",
      "common.numbers.four",
      "common.numbers.five"
    ];

    if (num >= 0 && num <= 5) {
      return this.$t(germanWords[num]);
    } else {
      return num.toString();
    }
  }
}
</script>

<style scoped>
.center {
  text-align: center;
}
</style>
